import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import withNotLogged from '../hocs/WithNotLogged';
import TopBanner from '../components/TopBanner';
import Header from '../components/Header';
import Navbar from '../components/Navbar';

const LayoutSub = () => {
    return (
        // <>
        //     <SubHeader />
        //     <Outlet />
        //     <Footer />
        // </>
        <>
            <TopBanner />
            <Header />
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
};
export default withNotLogged(LayoutSub);
